import { collection, getDocs, onSnapshot, query, where } from 'firebase/firestore';
import { db } from 'FirebaseInstance';
import { useEffect, useState } from 'react';

import { IMessagePayload } from 'shared/interfaces/ITalent';
import { IDocData } from 'shared/interfaces/utils/IMessages';
import { talentService } from 'shared/services/talentService';
import { ls } from 'shared/utils/ls';
import { captureMessage } from '../../lib/sentry';
export interface UseSendMessageProps {
  id: string;
  noteToSend: string;
  type: 'new-audition-requests';
  messageKey: 'agent_talent_messages' | 'casting_talent_messages';
  afterSend?: () => void;
  projectId: string;
}

const { sendMessage } = talentService();

export const useSendMessage = ({ id, noteToSend, type, messageKey, projectId, afterSend }: UseSendMessageProps) => {
  const { getLS } = ls();
  const [messages, setMessages] = useState<IMessagePayload['messages']>([]);
  const [docData, setDocData] = useState<IDocData | null>(null);
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);
  const user = JSON.parse(getLS('user'));
  const { mutateAsync: sendFirebaseMessage, isLoading: isSendingFirebaseMessage } = sendMessage();
  const fetchPost = async () => {
    // return console.log('fetchPost');

    try {
      const collectionRef = collection(db, type);
      const q = query(
        collectionRef,
        where('__name__', '==', projectId), // Filter by document ID
      );
      const querySnapshot = await getDocs(q);

      console.log({ querySnapshot });

      if (!querySnapshot.empty) {
        querySnapshot.forEach((doc) => {
          const data = doc.data();

          const messages = data[id]?.[messageKey] || []; // Access the nested array

          setMessages(messages); // Set the state with the messages array
        });
      } else {
        console.log('No matching document found!');
      }
      setLoading(false);
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {
    const q = query(
      collection(db, type),
      where('__name__', '==', projectId), // Filter by document ID
    );
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      if (!querySnapshot.empty) {
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          console.log({ data });

          const messages = data[id]?.[messageKey] || []; // Access the nested array

          setMessages(messages); // Set the state with the messages array
        });
      }
    });

    fetchPost();

    return () => unsubscribe();
  }, []);

  const send = async () => {
    try {
      fetchPost();
      setSending(true);
      const timestamp = new Date().getTime().toString();
      await sendFirebaseMessage({
        message_type: messageKey,
        audition_schedule_id: id,
        // concatenated message
        messages: [
          //modify messages viewed_by
          ...messages.map((message) => {
            if (message.sender !== user.id) {
              return {
                ...message,
                viewed_by: [
                  ...message.viewed_by,
                  {
                    user_id: user.id as string,
                    timestamp,
                  },
                ],
              };
            }
            return message;
          }),
          {
            type: 'Talent',
            note: noteToSend,
            sender: user.id,
            timestamp: timestamp,
            id: id + '-' + timestamp,
            viewed_by: [
              {
                user_id: user.id as string,
                timestamp,
              },
            ],
          },
        ],
      });
      setSending(false);
      if (afterSend) {
        afterSend();
      }
    } catch (error: any) {
      setSending(false);
      captureMessage({
        message: 'user failed to send message with error',
        data: error?.response,
        level: 'error',
      });
    }
  };

  return {
    send,
    loading,
    sending,
    messages,
    user,
  };
};
